import { connect } from 'react-redux';
import { get } from 'lodash';

import Login from './login.component';
import { setUpLoginSessionCallback, requestLoginSession, openLoginPopup } from './login.actions';
import { ILoginDispatchProps, ILoginStoreProps } from './login.types';

const mapStateToProps = (state: object): ILoginStoreProps => ({
    fetching: get(state, 'login.fetching'),
    loginSession: get(state, 'login.loginSession'),
    hasTPCEnabled: get(state, 'login.hasTPCEnabled'),
    activeLanguageCode: get(state, 'language.activeLanguageCode')
});

const mapDispatchToProps: ILoginDispatchProps = {
    setUpLoginSessionCallback,
    requestLoginSession,
    openLoginPopup
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);
